import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BankNote } from 'src/app/assabil-kernel/models/entities/control-tables/bank-note';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { BankNoteRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/bank-note-request';
import { Currency } from 'src/app/assabil-kernel/models/entities/control-tables/currency';


@Component({
  selector: 'app-bank-note-list',
  templateUrl: './bank-note-list.component.html',
  styleUrls: ['./bank-note-list.component.scss']
})

export class BankNoteListComponent extends BasePage2<BankNote> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  bankNotes: BankNote[] = [];
  // ---------------------------------------------------
  
  currenrys : Currency[];

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'bankNote';
  }



  listFields = [];


  ngAfterViewInit(){
    
    super.ngAfterViewInit();

    this.controlService.getList('currency', this.controlService.getRequest()).then(result => {
        this.currenrys = result;

        this.listFields = [
          { prop: 'bankNoteCode',   name:   'Code',         insertOnly : true},
          { prop: 'currency' ,      name :  'Code Monnaie', key : "currencyCode",  lov : {key : "currencyCode",  value : "name",  data : this.currenrys }  },
          { prop: 'name',           name:   'Name'         },
          { prop: 'theValue',       name :  'Valeur'       },
          { prop: 'rank',           name:   'Rang'         },
        ]
    })

  }

//----------------------------------------------------------------------
  getRows(): BankNote[] {
      return this.bankNotes;
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
  let entity : BankNote = new BankNote();
  entity.inserted = true;
  entity.edit = true;
  this.bankNotes.push(entity);
  this.bankNotes = [...this.bankNotes];
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(bankNote: BankNote): Promise<BankNote> {
  let request  : BankNoteRequest = new BankNoteRequest(this.controlService.getUserInfo());
  request.bankNote = bankNote;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
loadData() {
  let request         : BaseRequest = this.controlService.getRequest();
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlService.getList(this.entityName, request).then(result => {
      this.bankNotes = result;
  }).catch(error => {
      this.showError(error);
  })
}
//----------------------------------------------------------------------

}